angular.module 'zc.commonApi'

.factory "UntrackPageType", ($resource, $q, BaseProjectCrudService) ->
  class UntrackPageType extends BaseProjectCrudService

  new UntrackPageType(
    $resource
    $q
    "/api/projects/:projectId/untrack_page_types/:id"
    "untrack_page_type"
    "untrack_page_types"
  )



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/untrack_page_type_service.js.coffee